import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/client';

interface Props {
  ids: string[];
}

/**
 * 後台預覽用的「相關新聞」：仿前台接在內文最後的延伸閱讀區（apps/web render.ts relatedBox）。
 * 用編輯中的挑選（尚未儲存也看得到），queryKey 與 RelatedSection 共用快取。
 */
export default function PreviewRelatedNews({ ids }: Props) {
  const related = useQuery({
    queryKey: ['related', ids],
    queryFn: () => api.articlesByIds(ids),
    enabled: ids.length > 0,
  });
  if (ids.length === 0) return null;
  // API 不保證順序，依編輯挑選的順序排。
  const byId = new Map((related.data?.items ?? []).map((a) => [a.id, a]));
  const items = ids.flatMap((id) => byId.get(id) ?? []);

  return (
    <aside className="mt-8 border-t-2 border-gray-900 pt-3" aria-label="相關新聞">
      <h2 className="mb-3 text-base font-bold">相關新聞</h2>
      <ul className="m-0 grid list-none grid-cols-[repeat(auto-fit,minmax(240px,1fr))] gap-3 p-0">
        {items.map((a) => (
          <li key={a.id} className="flex items-center gap-3">
            {a.coverUrl ? (
              <img src={a.coverUrl} alt="" className="h-14 w-24 shrink-0 rounded object-cover" />
            ) : (
              <span className="h-14 w-24 shrink-0 rounded bg-gray-100" />
            )}
            <span className="text-sm leading-snug">{a.title}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
}
